
//import {db, functions} from "@/scripts/firebase";
import {FreeBusyStatus, SchedulingEntry, SchedulingSheet} from "@/common-datatypes";
import { Component,Mixins,Prop } from "vue-property-decorator"
import {query, Unsubscribe, onSnapshot, getDoc, where} from 'firebase/firestore'
//import { ValidationObserver } from 'vee-validate'
import Common from '@/mixins/common'
import { UserSentMessage } from "@/scripts/datatypes"
import ModalCreateEventByScheduling from "@/components/ModalCreateEventByScheduling.vue"

@Component({
  components: {
    ModalCreateEventByScheduling
  }
})


export default class SchedulingTable extends Mixins(Common) {
  @Prop({type: String, default: ''}) private schedulingSheetId?: string

  observers: (Unsubscribe | undefined)[] = []

  schedulingSheet = {} as SchedulingSheet

  schedulingEntries = [] as SchedulingEntry[]

  receiverUserIds: string[] = []

  receiverMeta: UserSentMessage['receiverMeta'] = {}

  entryUserIds: string[] = []

  freeBusyStatus = {
    free: {
      icon: this.$t('freeBusyStatus.free.icon'),
      text: this.$t('freeBusyStatus.free.text')
    },
    busy: {
      icon: this.$t('freeBusyStatus.busy.icon'),
      text: this.$t('freeBusyStatus.busy.text')
    },
    pending: {
      icon: this.$t('freeBusyStatus.pending.icon'),
      text: this.$t('freeBusyStatus.pending.text')
    }
  }

  entryMeta: {
    [key: string]: SchedulingEntry['userMeta'];
  } = {}

  isLoading = false


  get memberUserIds(){
    return Array.from(new Set(this.receiverUserIds.concat(this.entryUserIds)))
  }

  get memberMeta(){
    return {
      ...this.receiverMeta,
      ...this.entryMeta
    }
  }

  get dateValidities() {
    const validitiess: {[index: number]: number }  = {}

    const num = this.schedulingEntries.length

    this.schedulingEntries.forEach((entry) => {
      //const userId = entry.userId

      entry.reply.forEach((r) => {
        const time = r.value.getTime()
        if(! validitiess[time]){
          validitiess[time] = 0
        }

        if(r.status === 'free' && num > 0){
          validitiess[time] = validitiess[time] + 1 / num
        }
      })
    })

    return validitiess
  }

  get userReplies() {
    const userReplies: {[index: string]: {[index: number]: FreeBusyStatus }}  = {}

    this.schedulingEntries.forEach((entry) => {
      const userId = entry.userId as keyof typeof userReplies
      const reply: typeof userReplies[typeof userId] = {}

      entry.reply.forEach((r) => {
        const time = r.value.getTime()
        reply[time] = r.status
        
      })
      userReplies[userId] = reply
    })

    return userReplies
  }

  get userComment() {
    const userComment: {[index: string]: string }  = {}

    this.schedulingEntries.forEach((entry) => {
      const userId = entry.userId as keyof typeof userComment

      userComment[userId] = entry.comment
    })

    return userComment
  }

  get userPostStatus() {
    const userPostStatus: {[index: string]: string }  = {}

    this.schedulingEntries.forEach((entry) => {
      const userId = entry.userId as keyof typeof userPostStatus

      userPostStatus[userId] = entry.postStatus
    })

    return userPostStatus
  }
 
  async created(){
    console.trace('created')

    this.$store.commit("setLoading",true);
    this.isLoading = true
      
    try{
      if(this.schedulingSheetId){
      const schedulingSheetDoc = await getDoc(this.$getSchedulingSheetDocRef(this.schedulingSheetId))

        if(schedulingSheetDoc.exists()){
          this.schedulingSheet = {
            ...schedulingSheetDoc.data() as SchedulingSheet,
          }

          const sentMessageQuery = query(this.$getReferenceObjectUserSentMessageQuery([this.schedulingSheetId]),where('status','==','sent'))

          this.observers.push( onSnapshot(sentMessageQuery,(snapshot) => {
            snapshot.forEach((doc) => {
              const row = doc.data() as UserSentMessage
              this.receiverUserIds = Array.from(new Set(this.receiverUserIds.concat(row.receiverUserIds || [])))
              this.receiverMeta = {
                ...this.receiverMeta,
                ...row.receiverMeta
              }
            })
          }))

          const schedulingEntriesQuery = this.$getSchedulingEntriesQuery(this.schedulingSheetId)

          this.observers.push( onSnapshot(schedulingEntriesQuery,async (snapshot) => {
            snapshot.forEach((doc) => {
              const row = {
                ...doc.data(),
                docId: doc.id
              } as SchedulingEntry

              const findIndex = this.schedulingEntries.findIndex((entry) => {return entry.docId === doc.id})
              const deleteCount = (findIndex === -1 ? 0 : 1)
              this.schedulingEntries.splice(findIndex,deleteCount,row)

              this.entryUserIds.push(row.userId)
              this.entryMeta = {
                ...this.entryMeta,
                [row.userId]: row.userMeta
              }
            })
          
            this.$store.commit("setLoading",true);
            this.isLoading = true
            await this.$sleep(100)
            this.$store.commit("setLoading",false);
            this.isLoading = false
          }))
        }
      }
    }catch(error){
      console.log(error)
    }finally{
      //this.$store.commit("setLoading",false);
      //this.isLoading = false
    }
  }

  createEvent(date: Date){
    this.selectedDate = date
  }

  selectedDate = false as boolean | Date
 
  destroyed() {
    console.trace('destroyed')
    this.$unsubscriber(this.observers)
  }

}
